export const formatRegulationSummary = (summary) => {
  if (!summary) return summary;
  const formatedSummary = summary.replace(/\[.+?\]/, '');
  return formatedSummary;
};
